/**
 * @package DMV VIN Check
 * @version 1.0.0
 */

$(document).ready(function() {
  $('#vin-check-form').formValidation({
    framework: 'bootstrap',
    live: 'disabled',
    icon: {
      valid: 'icon icon-success',
      invalid: 'icon icon-danger',
      validating: 'fa fa-refresh',
    },
    fields: {
      vin: {
        validators: {
          notEmpty: {
            message: 'The VIN is required',
          },
          stringLength: {
            min: 17,
            max: 17,
            message: "The VIN is not valid",
          },
        },
      },
      email: {
        validators: {
          notEmpty: {
            message: 'The email is required',
          },
          emailAddress: {
            message: 'The email must be a valid email address',
          },
        },
      },
    },
  }).on('success.form.fv', function() {
    this.submit();
  });

  $('.vin-retry').on('click', function() {
    $('input[name=vin]').val($(this).text());
  });

  $('#vin-link').on('click', function(event) {
    event.preventDefault();
    if ($('input[name=vin]').val().length && $('input[name=email]').val().length) {
      window.location.href = 'https://secure.dmv.com/vin-report/' + $('input[name=vin]').val();
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-vin/index.js